import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { formatVal, valToPercent } from '../../../helpers/value'
import { SUB_TOTAL_ID } from './constant'
import classes from './index.module.scss'

export const CellTooltip = ({
  analyse,
  versus,
  value,
  totalCompany,
  onClickView,
}) => {
  const locale = useSelector((state) => state.i18n.locale)

  const getTitle = () => {
    if (analyse.id === SUB_TOTAL_ID && versus.id === SUB_TOTAL_ID) {
      return <Translate value="portfolio.summary.TOTAL_COMPANY" />
    }

    if (analyse.id === SUB_TOTAL_ID) {
      return versus.name
    }

    if (versus.id === SUB_TOTAL_ID) {
      return analyse.name
    }

    return `${analyse.name} - ${versus.name}`
  }

  return (
    <div className={classes.cellTooltip}>
      <Element className={classes.title} style={{ borderColor: '#3F4145' }}>
        {getTitle()}
      </Element>

      <div className={classes.item}>
        <Translate value="portfolio.summary.NUMBER_OF_COMPANIES" />
        <span>{formatVal(value, locale, false, 0)}</span>
      </div>
      <div className={classes.item}>
        <Translate value="portfolio.summary.PERCENT_OF_TOTAL_COMPANIES" />
        <span>{valToPercent(value / totalCompany, locale)}</span>
      </div>

      {!!value && (
        <div className="textEnd pt1" style={{ color: '#307EFF' }}>
          <span className="cursorPointer" onClick={onClickView}>
            <Translate
              value="portfolio.summary.VIEW_COMPANY"
              onClick={onClickView}
            />
          </span>
        </div>
      )}
    </div>
  )
}
